import {nanoid} from 'nanoid';

export function newUUID() : string {
    return nanoid();
}
